import GroupListItem from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsSelectedList/components/RestrictedVisibilitySettingsSelectedGroupsList/components/RestrictedGroupListItem';
import { ColumnShape } from '@/components/Table/types';
import { UserFragment } from '@/graphql/fragments/generated/User';
import { Tabs } from '@/modules/corporate/components/LearnerAndGroupDialog/types';
import LearnerListItem from '@/modules/corporate/modules/assignment/views/AssignmentCreator/components/LearnersAndGroupList/components/ListItem';

import { UserCollectionFragment } from '../../modules/group/views/GroupManager/graphql/fragments/generated/UserCollection';

export const getTableColumns = ({
  inViewTab,
  disabled,
  onRemoveUser,
  onRemovegroup,
}: {
  inViewTab: Tabs;
  disabled?: boolean;
  onRemoveUser: ({ removedUserId, isInGroups }: any) => void;
  onRemovegroup: ({ removedGroupId }: any) => void;
}): ColumnShape<UserFragment | UserCollectionFragment>[] => [
  {
    key: 'statusAndName',
    cellRenderer: ({ rowData }) => {
      const currentContent = rowData;

      if (inViewTab === Tabs.Learners) {
        return (
          <LearnerListItem
            key={currentContent.id}
            className="w-full"
            disabled={disabled}
            user={currentContent as UserFragment}
            onRemove={onRemoveUser}
          />
        );
      }

      return (
        <GroupListItem
          key={currentContent.id}
          className="w-full"
          disabled={disabled}
          group={currentContent as UserCollectionFragment}
          mode="normal"
          onRemove={onRemovegroup}
        />
      );
    },
    width: 800,
    flexGrow: 1,
  },
];
